import { PageShell } from '@/components/layout/PageShell'
import { VideoSectionConnected } from '@/features/settings/connected'

export default function AdminVideoPage() {
  return (
    <PageShell>
      <div className="mx-auto max-w-3xl pt-4 md:pt-6">
        <VideoSectionConnected />
      </div>
    </PageShell>
  )
}
